/**
 * <s-scroll-header> — sticky header wrapper that slides its first child (the
 * trust bar) out of view while scrolling down and brings it back on scroll up.
 * The header itself stays pinned. Respects prefers-reduced-motion through CSS.
 */
class SScrollHeader extends HTMLElement {
  #ac;
  #lastY = 0;
  #ticking = false;

  connectedCallback() {
    this.#ac = new AbortController();
    this.#lastY = window.scrollY;
    window.addEventListener('scroll', () => {
      if (this.#ticking) return;
      this.#ticking = true;
      requestAnimationFrame(() => {
        this.#update();
        this.#ticking = false;
      });
    }, { passive: true, signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
    this.style.transform = '';
  }

  #update() {
    const bar = this.firstElementChild;
    const y = window.scrollY;
    const delta = y - this.#lastY;
    if (Math.abs(delta) < 4) return;
    const height = bar ? bar.offsetHeight : 0;
    const hide = delta > 0 && y > height;
    this.style.transform = hide ? `translateY(-${height}px)` : '';
    this.#lastY = y;
  }
}

if (!customElements.get('s-scroll-header')) customElements.define('s-scroll-header', SScrollHeader);
